var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-layout',_vm._b({},'p-layout',_vm.$props,false),[_c('template',{slot:"body"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }